module.exports = __webpack_public_path__ + "img/vol05_cup01_cover02.be1f18f3.jpg";